import { SortOrder } from './userActionRecord';

export const DEFAULT_PER_PAGE = 50;

export type PaginationResult<T> = {
  data: T[];
  meta: PaginationMetadata;
};

export type PaginationMetadata = {
  current_page: number;
  first_page: number;
  last_page: number;
  per_page: number;
  total: number;
};

export type BasePaginationAndSearch<T> = {
  search?: string;
  page?: number;
  perPage?: number;
  sortBy?: keyof T;
  sortDirection?: SortOrder;
};
